require('./addonSelect.scss');

const deps = [];

module.exports = angular
  .module('bench.ui.addonSelect', deps)

  .directive('blAddonSelect', () => ({
    restrict: 'E',
    scope: {},
    bindToController: true,
    template: require('./addonSelect.html'),
    controller: require('./addonSelectCtrl.js'),
    controllerAs: 'vm',
  }));
